module.exports = __webpack_public_path__ + "img/banner@2x.b45c1746.jpg";